import React, { useState } from 'react'
import {
  IonCard,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonButtons,
} from '@ionic/react'
import { addCircleOutline } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import SInput from '../stringInput/StringInput.component'
import './AddEmail.component.css'

interface IValidationObject {
  id: string
  cardinality: string
}
interface IAddEmailProps {
  onSave: (email: string) => void
  label?: string
  buttonLabel?: string
  dataTestId?: string
  validationObj?: IValidationObject | null
}

const AddEmail = (props: IAddEmailProps) => {
  const { onSave, label = '', buttonLabel = '', dataTestId = '' } = props
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)
  const [emailValue, setEmailValue] = useState('')

  const handleAddClick = () => {
    setIsExpanded(true)
  }

  const handleEmailChange = (e: CustomEvent) => {
    setEmailValue(e.detail.value || '')
  }

  const handleSave = () => {
    if (emailValue.trim() && onSave) {
      onSave(emailValue.trim())
      setEmailValue('')
      setIsExpanded(false)
    }
  }

  const handleCancel = () => {
    setEmailValue('')
    setIsExpanded(false)
  }

  return (
    <>
      {isExpanded && (
        <IonCard className='ion-no-margin ion-margin-vertical'>
          <IonCardContent>
            <IonGrid className='no-padding'>
              <IonRow>
                <IonCol>
                  <SInput
                    label={label}
                    dataTestID={dataTestId}
                    inputValue={emailValue}
                    onChangeAction={handleEmailChange}
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
            <IonButtons className='email-card-buttons'>
              <IonButton
                data-testid='CancelEmail'
                className='btn btn-secondary btn-standard mr-8'
                expand='block'
                onClick={handleCancel}>
                {t('common.buttons.Cancel')}
              </IonButton>
              <IonButton
                data-testid='SaveEmail'
                className='btn btn-standard btn-primary'
                expand='block'
                disabled={!emailValue.trim()}
                onClick={handleSave}>
                {t('common.buttons.Save')}
              </IonButton>
            </IonButtons>
          </IonCardContent>
        </IonCard>
      )}
      {!isExpanded && (
        <IonRow className='ion-float-right'>
          <IonCol>
            <IonItem lines='none'>
              <IonButton
                data-testid={dataTestId || 'AddEmail'}
                className='transform-none multi-card-add-button'
                fill='clear'
                color='primary-alt'
                onClick={handleAddClick}>
                <IonIcon icon={addCircleOutline} />
                <IonLabel>{buttonLabel}</IonLabel>
              </IonButton>
            </IonItem>
          </IonCol>
        </IonRow>
      )}
    </>
  )
}

export default AddEmail
